import { FC } from 'react'

import { cloneDeep } from 'lodash'

import { Card, CardContent } from '../../../../components/ui/card'
import { Switch } from '../../../../components/ui/switch'

import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  selectRegistration,
  setRegistrationAc,
} from '../../../../store/registration/registrationSlice'

import FirestoreService from '../../../../services/firestoreService'

import useToasterHelper from '../../../../helpers/ToasterHelper'

import { CONST } from '../../../../const/const'
import { MESSAGES_CONST } from '../../../../const/messages-const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

interface SplitBillProps {
  isSplitBill: boolean
  setIsSplitBill: (value: boolean) => void
}

export const SplitBill: FC<SplitBillProps> = ({ isSplitBill, setIsSplitBill }) => {
  const toastFunctions = useToasterHelper()

  const dispatch = useAppDispatch()

  const registration = useAppSelector(selectRegistration)

  const onSplitChange = async (isChecked: boolean) => {
    if (!registration) return

    try {
      setIsSplitBill(isChecked)
      const registrationUpdated = cloneDeep({ ...registration, isSplit: isChecked })

      await FirestoreService.updateItem(COLLECTIONS.EVENT_REGISTERED_USERS.NAME, registration?.id, {
        isSplit: isChecked,
      })

      dispatch(setRegistrationAc(registrationUpdated))
    } catch (error: any) {
      toastFunctions.error({
        message: error?.message ?? MESSAGES_CONST.SOMETHING_WENT_WRONG,
      })
      console.error(error, 'error')
    }
  }

  return (
    <Card className="shadow-none border border-gray-200 rounded-xl mb-4">
      <CardContent className="p-4">
        <div className="flex gap-4 flex-wrap items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Do you want to split this bill?</h3>
            <p className="text-sm text-gray-600 mt-1">
              Enable this to assign individual items to different people
            </p>
          </div>
          <Switch checked={isSplitBill} onCheckedChange={onSplitChange} />
        </div>
      </CardContent>
    </Card>
  )
}
